// Export forms from barrel
export { default as Form_1 } from "./form1";
export { default as Form_2 } from "./form2";
export { default as Form_3 } from "./form3";
export { default as Form_9 } from "./form9";
export { Form_4 } from "./form4";
export { SegmentWorkbenchForm } from "./segmentWorkbench";
export { Form_5 } from "./form5";
export { default as Form_6 } from "./form6";
export { default as Form_7 } from "./form7";
export { default as Form_8 } from "./form8";

// Re-export types with namespacing to avoid conflicts
export type { FormProps as Form1Props, FormState as Form1State, Section as Form1Section } from "./form1/types";
export type { FormProps as Form2Props, FormState as Form2State, Section as Form2Section } from "./form2/types";
export type { FormProps as Form3Props, FormState as Form3State, Section as Form3Section } from "./form3/types";
export type { FormProps as Form4Props, FormState as Form4State, Section as Form4Section } from "./form4/types";
export type { FormProps as Form5Props, ListItem as Form5ListItem, Section as Form5Section } from "./form5/types";
export type { FormProps as Form6Props, Form6Config, TabItem, RowItem as Form6RowItem, ColumnItem as Form6ColumnItem, ValueItem as Form6ValueItem } from "./form6/types";
export type { FormProps as Form7Props, Section as Form7Section } from "./form7/types";
export type { FormProps as Form8Props, FormState as Form8State, Section as Form8Section, Category as Form8Category, MetadataItem as Form8MetadataItem } from "./form8/types";
export type { FormProps as Form9Props, FormState as Form9State, Section as Form9Section } from "./form3/types";
